<template>
  <div>
    <div :class="{'is-active': active}">
      <div>
        <header class="modal-card-head">
          <p class="modal-card-title">
            <span class="has-text-weight-bold">Création automatique de lots</span>
          </p>
        </header>
        <section class="modal-card-body is-padding">
          <p
            class="is-size-6 is-margin-left-xsmall is-margin-right-xsmall has-text-primary"
            v-show="['DOWNLOAD', 'UPLOAD'].includes(step)">
            Nous vous proposons de créer automatiquement les fiches des lots (logements et parking).<br>
            Pour cela il vous faut utiliser le gabarit Excel mis à votre disposition.<br>
            Vous ne devez pas le modifier (ajout/suppression de colonne) afin que la procédure de création se déroule correctement.<br>
          </p>
          <div
            class="columns is-gapless is-margin-top"
            v-show="step === 'DOWNLOAD'">
            <a
              @click="getImportUrl"
              class="column is-border is-border-dotted columns is-gapless is-vcentered is-margin-right-xsmall is-padding has-cursor-pointer is-marginless-bottom">
              <div class="column is-narrow is-margin-right"><i class="has-text-grey fal fa-cloud-download fa-4x"></i></div>
              <div class="column has-text-primary">
                <div class="is-margin-bottom-xsmall is-size-4"><b>Étape 1 :</b></div>
                <div class="is-underline is-size-6">Télécharger le modèle Excel à completer</div>
              </div>
            </a>
            <div
              @click="step = 'UPLOAD'"
              class="column is-border is-border-dotted columns is-gapless is-vcentered is-margin-left-xsmall is-padding has-cursor-pointer is-marginless-bottom">
              <div class="column is-narrow is-margin-right">
                <i class="has-text-grey fal fa-cloud-upload fa-4x"></i>
              </div>
              <div class="column has-text-primary">
                <div class="is-margin-bottom-xsmall is-size-4">
                  <b>Étape 2 :</b>
                </div>
                <div class="is-underline is-size-6">
                  Importer le modèle Excel complété
                </div>
              </div>
            </div>
          </div>
          <div
            class="columns is-gapless is-vcentered"
            v-show="step === 'CREATING'">
            <div class="column is-narrow w80p has-text-centered is-margin-right-small">
              <img
                src="/img/loading/spinner2.svg"
                alt="loader">
            </div>
            <div class="column">
              <div class="is-margin-bottom-xsmall has-text-grey">
                Création des fiches lots en cours
              </div>
              <progress
                class="progress is-small is-success"
                :value="progressData"
                max="100">
                {{ progressData }}%
              </progress>
            </div>
          </div>
          <div
            class="columns is-gapless is-vcentered"
            v-if="step === 'CONFIRM'">
            <div class="column is-narrow w80p has-text-centered is-margin-right-small">
              <i
                v-if="hasErrors"
                class="has-text-danger fas fa-engine-warning fa-3x"></i>
              <i
                v-else
                class="has-text-success fas fa-check-circle fa-3x"></i>
            </div>
            <div
              class="column"
              v-if="hasErrors">
              <div class="is-uppercase">
                <b><span>Erreur(s) détectée(s)</span></b>
              </div>
              <div class="is-uppercase has-text-danger is-size-6">
                <p
                  v-for="(error, i) in result.errors"
                  :key="i"
                  class="has-font-weight-medium">
                  -
                  <span v-if="error.row">Ligne : {{ error.row }} <br></span>
                  <span v-if="error.col">Colonne : {{ error.col }} <br></span>
                  <span>{{ error.description }}</span>
                </p>
              </div>
            </div>
            <div
              class="column"
              v-else>
              <div class="is-uppercase">
                <b><span>{{ result.valid }} fiches lot créées avec succès</span></b>
              </div>
            </div>
          </div>
          <div
            class="is-margin-top"
            v-show="step === 'UPLOAD' || (step === 'CONFIRM' && hasErrors)">
            <form enctype="multipart/form-data">
              <label
                class="file-label file-label--bigfield file-label--bigfield--striped is-border"
                :class="[fileLabelStaus, overClass]"
                @drop.prevent.stop="processFile($event.dataTransfer.files)"
                @dragenter.prevent.stop="dragoverHandler($event, 'is-validDrop')"
                @dragover.prevent.stop="dragoverHandler($event, 'is-validDrop')"
                @dragleave.prevent.stop="dragoverHandler($event)">
                <input
                  class="file-input"
                  type="file"
                  name="file"
                  accept=".xls,.xlsx"
                  @change="processFile($event.target.files)" />
                <div class="columns is-gapless w100 file-label-minHeight">
                  <div class="column w100 has-text-centered is-padding is-margin-small file-label-dashMe">
                    <div class="is-padding-bottom-small">
                      <i class="fal fa-cloud-upload fa-3x"></i>
                    </div>
                    <div class="file-label">
                      <div class="w100">
                        <b class="is-uppercase is-underline">Sélectionner un fichier sur votre ordinateur</b>
                        <div class="is-uppercase is-margin-top-xsmall">OU faites glisser les fichiers dans cette zone</div>
                      </div>
                    </div>
                  </div>
                </div>
              </label>
            </form>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
const STEPS = {
  DOWNLOAD: 'DOWNLOAD',
  UPLOAD: 'UPLOAD',
  CREATING: 'CREATING',
  CONFIRM: 'CONFIRM'
}

export default {
  name: 'ImportLots',
  props: {
    active: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      step: STEPS.DOWNLOAD,
      result: null,
      progressData: null,
      validDocument: null,
      overClass: null
    }
  },
  computed: {
    programPk () {
      if (this.$route.params.id) {
        return this.$route.params.id
      } else if (this.$route.query && this.$route.query.program) {
        return this.$route.query.program
      } else return null
    },
    templateFile () {
      return null// this.$configs
    },
    hasErrors () {
      if (this.result && this.result.errors) {
        return !!this.result.errors.length
      } else return false
    },
    fileLabelStaus () {
      if (this.validDocument) {
        return 'is-validDrop'
      } else if (this.validDocument === false) {
        return 'is-wrongDrop'
      } else return ''
    }
  },
  methods: {
    dragoverHandler (ev, status = null) {
      this.overClass = status
      ev.preventDefault()
    },
    async getImportUrl () {
      const { data } = await this.$api.get(this.$resources.CONFIG)
      if (!data || !data.length || !Array.isArray(data)) return
      let url = data.find(x => x.key === 'LOTS_IMPORT_TEMPLATE')
      url = url.value
      let link = document.createElement('a')
      link.href = url
      link.click()
    },
    async processFile (files) {
      this.$set(this, 'result', null)
      let file = files[0]
      let ext = file.name.split('.').pop()
      this.validDocument = ['xls', 'xlsx'].includes(ext)
      if (this.validDocument) {
        let newfiles = new FormData()
        await newfiles.append('file', file, file.name + 'download_name')
        let config = {
          onUploadProgress: progressEvent => {
            this.progressData = 33
          }
        }
        this.step = STEPS.CREATING
        setInterval(() => {
          this.progressData += 2
        }, 500)
        try {
          let { data } = await this.$api.post(this.$resources.IMPORT_LOT(this.programPk), newfiles, config)
          this.progressData = 100
          setTimeout(() => {
            this.step = STEPS.CONFIRM
          }, 700)
          this.$set(this, 'result', data)
          this.validDocument = null
          this.$emit('reloadLots')
          this.overClass = null
        } catch (e) {
          console.log(e)
          this.progressData = 100
          this.validDocument = null
          this.$emit('reloadLots')
          this.$toasted.global.danger('Impossible de télécharger le fichier, veuillez essayer plus tard.')
          this.step = STEPS.DOWNLOAD
          this.overClass = null
        }
      }
    }
  }
}
</script>
